import { connect } from "react-redux"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { getCompletedSellerOfferIds } from "modules/Seller/Offers/selectors"

const mapStateToProps = (state: Store) => ({
  offerIds: getCompletedSellerOfferIds(state),
})

export default connect(mapStateToProps)(View)
